import { render, staticRenderFns } from "./UserKanonismoiMenu.vue?vue&type=template&id=69bd4254&scoped=true"
import script from "./UserKanonismoiMenu.vue?vue&type=script&lang=js"
export * from "./UserKanonismoiMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bd4254",
  null
  
)

export default component.exports